const styles = (theme) => ({
  dialogContainer: {
    display: "flex",
    userSelect: "none",
    justifyContent: "center",
    height: "100%",
    "&>.formStyle": {
      width: "40%",
      boxSizing: "border-box",
      minWidth: 600,
      maxWidth: 750,
      display: 'flex',
      flexDirection: 'column',
    },
    "&>.mapStyle": {
      width: "60%",
      boxSizing: "border-box",
    },
  },
  formContainer: {
    borderRadius: "4px",
    padding: "15px",
    marginRight: 5,
  },
  dialog: {
    padding: "19px 23px",
    display: "flex",
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    fontWeight: "600",
  },
  dialogWrapper: {},
  dialogContents: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    overflowX: 'hidden',
    overflowY: 'auto',
    flex: 'auto',
    paddingRight: 16,
  },
  divider: {
    borderBottom: `1px solid ${theme.gridIconBorderColor}`,
    width: "100%",
    opacity: "0.7",
    height: "0px",
  },
  closeButton: {
    position: "absolute",
    right: 13,
    top: 22,
    color: theme.iconColor,
  },
  title: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    top: "19px",
  },
  selectFilterClass: {
    direction: "column",
    marginRight: 8,
    width: "160px",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  rightInfoGrid: {
    marginRight: 8,
  },
  greedRoot: {
    flexGrow: 1,
  },
  paper: {
    padding: 5,
    textAlign: "left",
  },
  input: {
    color: theme.TextColor,
    height: 43,
    fontSize: 12,
  },
  InputLabelProps: {
    color: theme.iconColor,
    transform: "translate(14px, 13px) scale(1)",
  },
  inputAdornment: {
    color: theme.iconColor,
  },
  closedDay: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    paddingBottom: 20,
  },
  deliveryDetails: {
    fontSize: theme.textFontSize,
    fontWeight: "bold",
  },
  textFieldClass: {
    paddingBottom: 10,
    paddingRight:10,
    marginTop: 16,
    width: "160px !important",
    color: theme.TextColor,
  },
  disabledDefaultHours: {
    opacity: 0.4,
    pointerEvents: "none",
  },
  tabContainer: {
    color: theme.TextColor,
    width: "100%",
    borderBottom: `1px solid ${theme.AppBGColor}`,
  },
  tabRoot: {
    textTransform: "none",
    fontSize: theme.headerTextFontSize,
    color: theme.HeaderDefaultTextColor,
    fontWeight: 600,
    "&$tabSelected": {
      color: theme.HeaderSelectedText,
    },
    "&:hover": {
      color: theme.HeaderSelectedText,
      opacity: 1,
    },
  },
  tabSelected: {},
});

export default styles;